<template>
  <router-view />
</template>

<script>
  export default {
    name: 'App',
    metaInfo () {
      return {
        title: 'Noisypeak Playout',
        titleTemplate:
          '%s | Noisypeak Playout',
      }
    },
    created () {
    },
    methods: {
    },
  }
</script>
